import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	open: {
		id: 'software-code-code-page.common.pr-status-lozenge.open',
		defaultMessage: 'OPEN',
		description: 'Tag to specify that a pull request is open.',
	},
	merged: {
		id: 'software-code-code-page.common.pr-status-lozenge.merged',
		defaultMessage: 'MERGED',
		description:
			'Tag to specify that the pull request in this row of the table was merged. \n' +
			'"Merge" is a technical term from the git tool and is most often not translated. Transliteration is acceptable.' +
			'This message is in the past tense. Some languages may keep the term in English "MERGED", ' +
			'some tense-less languages may keep the transliterated version of MERGE (Chinese, Malay...), ' +
			'while some languages might adapt the English technical term to their own past-tense system (eg MERGEADO in Portuguese, etc)',
	},
	declined: {
		id: 'software-code-code-page.common.pr-status-lozenge.declined',
		defaultMessage: 'DECLINED',
		description: 'Tag to specify that a pull request was declined',
	},
	unknown: {
		id: 'software-code-code-page.common.pr-status-lozenge.unknown',
		defaultMessage: 'UNKNOWN',
		description: 'Tag to specify that a pull request is in an unknown state',
	},
});
